import { useEffect, useMemo, useState } from 'react'

import type { UseChangedFieldsParams, UseChangedFieldsReturn } from './types'

export const useChangedFields = (params: UseChangedFieldsParams): UseChangedFieldsReturn => {
  const { changedMessage, changedSampleIds } = params

  const [isAddedComment, setIsAddedComment] = useState(false)

  useEffect(() => {
    const changedCommentFields = [changedMessage, changedSampleIds]
    const oneOfCommentFieldsChanged = changedCommentFields.some(value => value)

    setIsAddedComment(oneOfCommentFieldsChanged)
  }, [changedMessage, changedSampleIds])

  const isReadyToSubmitForm = useMemo(() => isAddedComment, [isAddedComment])

  return {
    isReadyToSubmitForm
  }
}
